import { useEffect, useRef } from 'react';
import { OnboardingFormFields } from '@Types/index';
import type { IBusinessAddressForm } from '../businessAddressForm/businessAddressSchema';
import type { Country } from '@Types/country';

interface ChangeCountryBusinessParams {
  selectedCountry: Country | undefined | null;
  isSameAddress: boolean;
  country: string | undefined | null;
  state: string;
  postalCode: string;
  city: string;
  resetField: (
    field: keyof IBusinessAddressForm,
    options: { defaultValue: IBusinessAddressForm[keyof IBusinessAddressForm] }
  ) => void;
  clearErrors: (fields: (keyof IBusinessAddressForm)[]) => void;
  setValue: (
    field: keyof IBusinessAddressForm,
    value: IBusinessAddressForm[keyof IBusinessAddressForm]
  ) => void;
  setIsDisableValidateAutoComplete: (value: boolean) => void;
}

export const useChangeCountryBusiness = ({
  country,
  city,
  clearErrors,
  isSameAddress,
  postalCode,
  resetField,
  selectedCountry,
  setValue,
  state,
  setIsDisableValidateAutoComplete,
}: ChangeCountryBusinessParams) => {
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (!selectedCountry) return;
    setIsDisableValidateAutoComplete(true);
    if (isSameAddress) return;
    clearErrors([
      OnboardingFormFields.STATE,
      OnboardingFormFields.ZIP,
      OnboardingFormFields.APARTMENT,
    ]);

    const shouldAutoPopulate = selectedCountry.code == country && country;
    if (shouldAutoPopulate) {
      const nonUsState = selectedCountry.subDivisions.find(
        (subDivision) => subDivision.code === state
      );
      const nonUsStateDropDownItem = {
        title: nonUsState ? nonUsState?.name : '',
        value: nonUsState ? nonUsState?.code : '',
      };
      setValue(OnboardingFormFields.ZIP, postalCode);
      setValue(OnboardingFormFields.CITY, city);
      setValue(OnboardingFormFields.STATE, nonUsStateDropDownItem);
    } else {
      resetField(OnboardingFormFields.STATE, { defaultValue: { title: '', value: '' } });
      resetField(OnboardingFormFields.ZIP, { defaultValue: '' });
    }
    if (selectedCountry.subDivisions?.length === 0) {
      resetField(OnboardingFormFields.STATE, { defaultValue: undefined });
    }
    setTimeout(() => {
      setIsDisableValidateAutoComplete(false);
    }, 50);
  }, [
    clearErrors,
    selectedCountry?.code,
    resetField,
    selectedCountry,
    setIsDisableValidateAutoComplete,
    isSameAddress,
    country,
    setValue,
    postalCode,
    city,
    state,
  ]);
};
